import React from "react";
import { safe } from "../utils/format";

export default function UserCard({ data, patientInfo }) {
  if (!data) return null;

  const profile = data.patient?.health_profile || {};

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) return "Good Morning 👋";
    if (hour >= 12 && hour < 17) return "Good Afternoon 👋";
    if (hour >= 17 && hour < 22) return "Good Evening 👋";
    return "Greetings 👋";
  };

  return (
    <div className="top-card">
      <h2 style={{ fontSize: 20, fontWeight: 700 }}>
        {getGreeting()}
      </h2>

      <div style={{ marginTop: 15, lineHeight: "26px", fontSize: 18 }}>
        <div><strong>Patient ID:</strong> {safe(patientInfo?.patientId)}</div>
        <div><strong>Age:</strong> {safe(profile.age)}</div>
        <div><strong>Gender:</strong> {safe(profile.gender)}</div>
      </div>
    </div>
  );
}